import snakecaseKeys from 'snakecase-keys';
import { CosmosFeegrantV1Beta1Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgRevokeAllowance extends MsgBase {
    static fromJSON(params) {
        return new MsgRevokeAllowance(params);
    }
    toProto() {
        const { params } = this;
        const message = CosmosFeegrantV1Beta1Tx.MsgRevokeAllowance.create();
        message.granter = params.granter;
        message.grantee = params.grantee;
        return CosmosFeegrantV1Beta1Tx.MsgRevokeAllowance.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/cosmos.feegrant.v1beta1.MsgRevokeAllowance',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'cosmos-sdk/MsgRevokeAllowance',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/cosmos.feegrant.v1beta1.MsgRevokeAllowance',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/cosmos.feegrant.v1beta1.MsgRevokeAllowance',
            message: proto,
        };
    }
    toBinary() {
        return CosmosFeegrantV1Beta1Tx.MsgRevokeAllowance.encode(this.toProto()).finish();
    }
}
